export default __webpack_public_path__ + "static/media/mockup-step-4.86cd44d6.png";